import type { ScreenSchema } from './types';

/**
 * Schema for the voicemail-question composite template.
 *
 * This template renders `screen-voicemail` (left) alongside `screen-question`
 * (right) on the same screen object. Because all content lives on the same YAML
 * screen object (no nested child screens), the question text is folded directly
 * into the intro slot so the full context is narrated when the section activates.
 *
 * Audible content:
 *   - `intro` — heading → text → instructions → question
 *
 * Note: the voicemail recording itself is a native <audio> asset and is not
 * schema-driven. screen-voicemail.vue calls stop() when the recording plays,
 * correctly interrupting any active narration. Question feedback (correct /
 * incorrect) is managed by the nested screen-question component.
 */
const voicemailQuestionSchema: ScreenSchema = {
  template: 'voicemail-question',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        { field: 'question' }
      ]
    }
  }
};

export default voicemailQuestionSchema;
